import _extends from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CommonContent from "~/components/CommonContent";
import PageTitle from "~/components/PageTitle";
import { mapState } from "vuex";
export default {
  components: {
    CommonContent: CommonContent,
    PageTitle: PageTitle
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          query = _ref.query;
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return store.dispatch("getPageData", { id: "[1,2]", lang: query.lang });

            case 2:
              result = _context.sent;
              return _context.abrupt("return", { pageData: result });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {};
  },

  methods: {
    reads: function reads(val) {

      var reg = /src="/g;
      if (this.lang === 'en') {
        return val.replace(reg, 'src="http://adminen.dongliyuanlin.com');
      } else {
        return val.replace(reg, 'src="http://admin.dongliyuanlin.com');
      }
    }
  },
  computed: _extends({}, mapState(["winHeight", 'lang']), {
    up: function up() {
      return {
        height: this.winHeight - 60 + "px"
      };
    },
    descPageData: function descPageData() {
      var _this = this;

      return this.pageData.map(function (val, key) {
        return _this.pageData[_this.pageData.length - 1 - key];
      });
    },
    pageName: function pageName() {
      if (this.lang === 'en') {
        return 'Brief introduction to Dongli';
      } else {
        return '东丽简介';
      }
    },
    dev: function dev() {
      if (this.lang === 'en') {
        return 'The Journey of Development';
      } else {
        return '发展历程';
      }
    }
  }),
  filters: {
    sub: function sub(val) {
      return val.substr(0, 10);
    }
  },
  created: function created() {
    console.log(this.pageData);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/us/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/us/index.vue
// module chunks = 7